export default __webpack_public_path__ + "static/media/single-project-page-03-img06.39cebdf6.jpg";